module.exports = "/next-static/_next/static/images/easyGuestManagement-c41c77d47028c8342f40b0b0619c677d.png";